export const MatchStatusIcons = () =>
  // todo: [PROF-2224] add status icons once api provides necessary data
  null;
